import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

export const BodyGridContainer = styled(Grid)`
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    margin-top: 10px;
    display: flex;
    padding: 12px 16px 2px 16px;
    ${media.mediumDevice`
        text-align:left;
    `}
    ${media.smalDevice`
        padding: 25px 16px;
    `}
    ${media.mobileDevice`
    //width: auto;
    display: block;
`}
`;

export const UserName = styled(Grid)`
    cursor: pointer;
    color: #1010eb;
    font-size: 15px;
    padding-right: 4px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.12px;
    ${media.mobileDevice`
      text-align: left; 
      //margin-left: 14px;
      padding-left: 0px;
      width: max-content;
    `}
`;

export const NameGrid = styled(Grid)``;

export const Heading = styled(Grid)`
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    // margin-top: 23px;
    letter-spacing: -0.1px;
    color: #000000;
    // width: max-content;
    ${media.mobileDevice`
    //padding-left: 14px;
`}
`;

export const AccountPaginationWrapper = styled.div`
    ${media.mobileDevice`
    position: fixed;
    width: 100%;
    bottom: 0;
    margin: 0 auto;
    `}
`;

export const DesktopView = styled.div`
    display: block;
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
        width: 100% !important;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        width: 100%;
    }
    ${media.mobileDevice`
        display: none;
    `}
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        padding-top: 10px;
        justify-content: space-between;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      padding ? padding : '1.125rem'
                  }, calc(4*env(safe-area-inset-bottom)))`
                : padding
                ? padding
                : '1.125rem'} 
    `}
`;

export const PopupContainer = styled.div`
    display: block;
    overflow: hidden;
    padding: 20px;
    ${media.mobileDevice`
    padding: 0px; 
`}
`;

export const PaginationContainer = styled.div`
    height: 48px;
    box-shadow: none;
    border-radius: 4px 4px 0px 0px;

    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mobileDevice`
    flex-direction:column;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;        
`}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color:#f5f5f5;
    `}
`;

export const RoleGrid = styled(Grid)``;

export const Line = styled(Grid)`
    display: none;
    ${media.mobileDevice`
      display: block;
      padding-left: 7px;
    `}
`;

export const DropDownStyle = styled(Grid)`
    display: none;
    ${media.smalDevice`
    display: ${(props) => (props.adminSearchOpen ? 'none' : 'flex')};
    width: 300px;
    height: 40px;
    border-radius: 6px;
    align-items: center;
    `}
    ${media.mobileDevice`
    width: 100%;
    `}
    .p-dropdown-label {
        color: #202124;
    }
    .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
        border-bottom: 0.5px solid #70707070 !important;
    }
`;

export const StyledSortIcon = styled.div`
    display: none;
    ${media.mobileDevice`  
    display: block;
    margin: 0px 10px 0 0; 
    width: 18px;
    height: 16px;
    `}
`;

export const Container = styled(Grid)`
    display: block;
    ${media.mobileDevice`
      display: flex;
      width: max-content;
    `}
`;

export const NetworkGrid = styled(Grid)``;

export const Desktop = styled(Grid)`
    padding-left: 10px;
    ${media.mediumDevice`
    padding-left: 10px;`}
    ${media.mobileDevice`
      display: none;
    `}
    &.impersonate-box {
        @media screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
            // padding-left: 12px;
        }
        @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
            padding-left: 10px;
        }
        @media only screen and (min-device-width: 1112px) and (orientation: landscape) {
            padding-left: 5px;
        }
    }
`;

export const Mobile = styled(Grid)`
    display: none;
    ${media.mobileDevice`
      display: flex;
      justify-content: space-between;
      padding: 20px 0px 0 0px !important;
      order: 5;
    `}
`;

export const SalesGrid = styled(Grid)`
    word-break: break-all;
    overflow-wrap: break-word;
    ${media.mediumDevice`
        padding-right: 10px;
    `}
    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        padding-right: 10px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-right: 10px;
    }
    ${media.smalDevice`
        padding-right: 10px;
        order: 5;
        display: flex;
    `}
    ${media.mobileDevice`
        order: ${(props) => props.gridOrder && props.gridOrder};
        display: block;
    `}

    .lock-icon-div {
        align-content: end;
        align-items: baseline;
        ${media.mobileDevice`
            align-content: unset;
            align-items: unset;
    `}
    }
`;

export const Role = styled(Grid)`
    color: #202124;
    font-size: 14px;
    // padding: 20px 0 0 12px;
    font-family: 'AvenirNextWorld Regular';
    opacity: 0.7;
    ${media.mobileDevice`
      padding-top: 0px;
      width: max-content;
    `}
`;

export const Network = styled(Grid)`
    color: #202124;
    font-size: 14px;
    // padding: 20px 0 0 19px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
      //padding: 0px 0 0 13px;
      width: max-content;
    `}
`;

export const Sales = styled(Grid)`
    color: #140f4b;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.11px;
    ${media.mobileDevice`
      padding-top: 5px;
      width: max-content;
    `}
`;

export const EditIconContainer = styled(Grid)`
    width: 92px;
    height: 36px;
    background: #ffffff;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #1010eb;
    border-radius: 25px;
    margin-bottom: 10px;
    ${media.smalDevice`
        margin-bottom: 0;
    `}
`;

export const SortIcon = styled(Grid)`
    cursor: pointer;
    margin-left: ${(props) => props.marginLeft && props.marginLeft};
`;

export const OtherSalesDiv = styled(Grid)`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
   // opacity: 0.6;
    ${media.mobileDevice`
        //padding-left: 13px;
        display: inherit;
        word-break: break-word;
        
    `}
`;

export const Sales1 = styled(Grid)`
    font-size: 15px;
    color: #a3a3a3;
    font-family: 'AvenirNextWorld Regular';
    // padding-top: 20px;
    ${media.mobileDevice`
    width: max-content;
    //padding: 0 0 0 13px;
    color: #140F4B;
    `}
    &.before-lock-icon-div {
        /* padding-right: 30px; */
        word-break: break-all;
        ${media.mediumDevice`
            padding-right: 15px;
        `}
        ${media.smalDevice`
            padding-right: 0;
        `}
        ${media.mobileDevice`
            padding-left: 0;
            word-break: normal;  
            padding-right: 0;
        `}
    }
`;

export const Sales3 = styled(Grid)`
    font-size: 13px;
    color: #000000;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    ${media.smalDevice`
        display: inline;
    `}
`;

export const Sales2 = styled(Grid)`
    font-size: 13px;
    color: #000000;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.1px;
    padding-right: 3px;
    opacity: 0.6;
    ${media.smalDevice`
    display: inline;
    `}
    ${media.mobileDevice`
    display: inline;
    padding-right: 0px;
    
    `}
`;

export const SapId = styled(Grid)`
    // padding-left: 18px;
    ${media.mobileDevice`
   padding-left: 7px;
   `}
`;

export const ImpersonateIconContainer = styled(Grid)`
    width: 144px;
    height: 36px;
    background: ${(props) => (props.backColor ? props.backColor : '#ffffff')};
    box-shadow: ${(props) =>
        props.boxShadow ? props.boxShadow : '0px 0px 2px #00000029'};
    border: ${(props) => (props.border ? props.border : '1px solid #1010eb')};
    border-radius: 25px;
    margin-bottom: 20px;
    ${media.mediumDevice`
    width: 128px;
   `}
`;

export const ImpersonateContainer = styled(Grid)`
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    padding: 5px 0 0 15px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    ${media.mediumDevice`
    padding: 4px 8px;
   `}
    ${media.mobileDevice`
    padding: 4px 4px 4px 10px;
   `}
`;

export const StyledImage = styled.img`
    display: flex;
    object-fit: contain;
    cursor: pointer;
    padding-bottom: 2px;
`;

export const StyledIcon = styled.img`
    display: flex;
    cursor: pointer;
    margin-right: 20px;
    margin-left: 10px;
    ${media.smalDevice`
        margin-right: 40px;
   `}
    ${media.mobileDevice`
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
   `}
`;

export const EditContainer = styled(Grid)`
    color: #1010eb;
    padding: 5px 0 0 12px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
`;

export const ButtonLabel = styled.label`
    display: flex;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 15px;
    color: ${(props) => (props.labelColor ? props.labelColor : '#1010eb')};
    cursor: ${(props) =>
        props.labelColor === '#9f9f9f' ? 'unset' : 'pointer'};
    margin-left: 4px;
`;

export const ActionGrid = styled(Grid)`
    text-align: center;
    // padding: 10px 10px 0 10px;
    ${media.mediumDevice`
padding-left: 0px;
`}
    ${media.smalDevice`
        order: 4;
    `}
    ${media.mobileDevice`
        order: 5;
    `}
`;

export const RadioButtonView = styled.div`
    margin-top: 3px;
`;

export const SalesDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    ${media.mobileDevice`
    padding-bottom: 18px;
    display: inherit;
    word-break: break-word;
    `}
`;

export const HeaderGridContainer = styled(Grid)`
    background: #ffffff;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    align-items: center;
    padding: 12px 16px;
    position: sticky;
    top: 0px;
    ${media.smalDevice`
        display: none !important;
    `}
`;
export const HeaderTextContainer = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    white-space: nowrap;
    color: #3c3c3c;
    opacity: 0.7;
    display: flex;
`;

export const HeaderTextContainer1 = styled(Grid)`
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 13px;
    // padding-left: 8px;
    color: #3c3c3c;
    opacity: 0.7;
    padding-left: 10px;
    ${media.mediumDevice`
    padding-left: 10px;`}
`;

export const BodyTextContainer1 = styled(Grid)`
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
`;

export const SearchDiv = styled.div`
    display: none;
    padding-right: 15px;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    ${media.smalDevice`
display: block;
`}
    ${media.mobileDevice`
display: none;
`}
`;

export const MainContainer = styled(Grid)`
    display: block;
    /* margin: 10px 0; */
    flex-direction: column;

    @media only screen and (min-width: 768px) and (max-width: 790px) {
        flex-direction: row;
        align-items: center;
    }
    ${media.smalDevice`
    flex-direction: row;
    align-items: center;
    `};
    ${media.mobileDevice`
    display: block;
    `};
    .title-search {
        ${media.smalDevice`
         display: block;
        `};
        ${media.mobileDevice`
            display: block;
        `};
    }
`;

export const SearchContainer = styled(Grid)`
    display: flex;
    ${media.mobileDevice`
    margin: 8px 0;
    `}
`;

export const SubMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 0 5px;
    ${media.mobileDevice`
    flex-direction: column;
    align-items: unset;
    margin: 0 0 5px !important;
    `}
    @media only screen and (min-width: 768px) and (max-width: 790px) {
        width: 100%;
        margin: 0;
    }
    ${media.smalDevice`
    width: 100%;
    margin: 0;
    `}
`;

export const SearchBoxContainer = styled.div`
    width: 354px;
    display: flex;
    ${media.mobileDevice`
    margin: 0 0 10px 0;
    max-width: 335px;
    `};
    @media only screen and (max-device-width: 375px) {
        max-width: 100%;
    }
    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        right: ${({ right }) => (right ? right : '')};
    }
    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        // right: 12%;
    }
`;

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        margin-top: -8.75rem;
        position:relative;
        margin-bottom:20px;
    `}
`;
export const ProductGuideListContainerHeader = styled.div`
    position: relative;
    background: #f5f5f5;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 6px;
    ${media.mobileDevice`
        display: block;
        margin: -4px 0 0 0;
        border-top-left-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        border-top-right-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        
        padding: 20px 16px 0 16px;
        height: auto;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
    `}
`;

export const ProductGuideListContainer = styled.div`
    height: ${(props) =>
        props.isImpersonationActive
            ? 'calc(100vh - 300px)'
            : 'calc(100vh - 320px)'};
    overflow-y: scroll;
    padding: 0 2px;
    padding-bottom: 120px;

    &::-webkit-scrollbar {
        display: block;
        width: 7px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: 10px;
        height: 10rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #888;
    }

    @media only screen and (min-width: 768px) and (max-width: 790px) {
        height: calc(100vh - 280px);
    }
    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 990px) and (max-device-width: 1100px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    @media only screen and (min-width: 1110px) and (max-width: 1122px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    ${media.mediumDevice`
        padding-bottom: 120px;
        &::-webkit-scrollbar {
            display:  none;  
        }
    `}
    ${media.smalDevice`
        padding-bottom: 120px;
        height: calc(100vh - 265px);
        flex-direction: column;
        &::-webkit-scrollbar {
            display:  none;  
        }
    `}

    ${media.mobileDevice`
        display: block;
        height: auto;
        padding-bottom: 240px;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        &::-webkit-scrollbar {
            display:  none;  
        }
    `}
`;

export const HeaderDiv = styled.div`
    padding: 16px 0px 16px 0px;
`;

export const HR = styled.hr`
    position: absolute;
    left: 0;
    right: 0;
    top: 120px;
    z-index: -1;
    width: 100%;
    border: 1px solid #707070;
    opacity: 0.2;
    background-color: #707070;
    ${media.mobileDevice`
        display: none;
    `}
`;

export const TextFont = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #1010eb;
`;

export const Line1 = styled(Grid)`
    border-top: 1px solid #e8e8e8;
    margin: 7px -7px -8px -7px;
`;

export const OtherSalesGrid = styled(Grid)`
    &.smalDevicePadding {
        @media screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
            // padding-left: 30px;
        }
    }
`;
